import { render } from "./CheckWorkSettingForm.vue?vue&type=template&id=1987c1c5"
import script from "./CheckWorkSettingForm.vue?vue&type=script&lang=js"
export * from "./CheckWorkSettingForm.vue?vue&type=script&lang=js"

import exportComponent from "D:\\develop\\app\\cw\\financial\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__